(function () {
  'use strict';

  /* ── Farbpaletten pro Kategorie ──────────────── */
  var PALETTES = {
    cbd:     ['#00C875','#00D4C8','#52B788','#7CB518','#1A936F'],
    sport:   ['#0070FF','#00A8E0','#FF6B00','#FFB700','#00C875'],
    beauty:  ['#FF006E','#C77DFF','#FF5CAA','#E040FB','#FF3CAC'],
    sleep:   ['#4A00E0','#8E2DE2','#6600CC','#2D00F7','#1A0050'],
    default: ['#00E5FF','#FF006E','#7B00FF','#0088FF','#FF3CAC'],
  };

  /* Blob-Positionen: x, y, size, opacity, morph-speed, drift-speed, delay */
  var BLOBS = [
    { bx:'16%',  by:'18%', bs:'580px', bo:'0.30', bmd:'14s', bdd:'18s', bd:'0s'   },
    { bx:'80%',  by:'72%', bs:'520px', bo:'0.28', bmd:'18s', bdd:'22s', bd:'1.5s' },
    { bx:'52%',  by:'12%', bs:'460px', bo:'0.24', bmd:'22s', bdd:'16s', bd:'0.8s' },
    { bx:'22%',  by:'78%', bs:'500px', bo:'0.26', bmd:'16s', bdd:'20s', bd:'2.2s' },
    { bx:'85%',  by:'22%', bs:'420px', bo:'0.22', bmd:'20s', bdd:'24s', bd:'3.0s' },
  ];

  function detectPalette() {
    var p = (window.location.pathname + ' ' + document.title).toLowerCase();
    if (/cbd|hanf|hemp|oil|öl|oel|cannab/.test(p)) return 'cbd';
    if (/sport|fit|train|energy|aktiv/.test(p))    return 'sport';
    if (/beauty|skin|pflege|kosmetik|haar/.test(p)) return 'beauty';
    if (/sleep|schlaf|relax|ruhe|beruhig/.test(p)) return 'sleep';
    return 'default';
  }

  /* ── Blobs aufbauen ─────────────────────────── */
  function buildBlobs() {
    var colors = PALETTES[detectPalette()];
    var frag = document.createDocumentFragment();

    BLOBS.forEach(function (cfg, i) {
      var el = document.createElement('div');
      el.className = 'liq-blob';
      el.style.background = colors[i];
      el.style.left   = cfg.bx;
      el.style.top    = cfg.by;
      el.style.width  = cfg.bs;
      el.style.height = cfg.bs;
      el.style.marginLeft = 'calc(' + cfg.bs + ' / -2)';
      el.style.marginTop  = 'calc(' + cfg.bs + ' / -2)';
      el.style.setProperty('--bo',  cfg.bo);
      el.style.setProperty('--bmd', cfg.bmd);
      el.style.setProperty('--bdd', cfg.bdd);
      el.style.setProperty('--bd',  cfg.bd);
      frag.appendChild(el);
    });

    document.body.appendChild(frag);

    /* Sanft einblenden */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.querySelectorAll('.liq-blob').forEach(function (b) {
          b.classList.add('is-visible');
        });
      });
    });
  }

  /* ── Kategorie-Link Hover: Farb-Preview ────── */
  function hookCategoryLinks() {
    var blobs = null;
    document.addEventListener('mouseover', function (e) {
      var link = e.target.closest('a[href*="/collections/"]');
      if (!link) return;
      if (!blobs) blobs = Array.from(document.querySelectorAll('.liq-blob'));
      var href = link.getAttribute('href').toLowerCase();
      var pal;
      if (/cbd|hanf|hemp|oil|öl|oel/.test(href)) pal = 'cbd';
      else if (/sport|fit|train/.test(href))      pal = 'sport';
      else if (/beauty|skin|pflege/.test(href))   pal = 'beauty';
      else if (/sleep|schlaf|relax/.test(href))   pal = 'sleep';
      else pal = 'default';
      var colors = PALETTES[pal];
      blobs.forEach(function (b, i) { b.style.background = colors[i % colors.length]; });
    });
    document.addEventListener('mouseout', function (e) {
      if (!e.target.closest('a[href*="/collections/"]')) return;
      if (!blobs) return;
      var colors = PALETTES[detectPalette()];
      blobs.forEach(function (b, i) { b.style.background = colors[i % colors.length]; });
    });
  }

  /* ── Boot ────────────────────────────────────── */
  function init() {
    buildBlobs();
    hookCategoryLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
